export default function Hero() {
  const stats = [
    { value: '365天', label: '不间断更新' },
    { value: '10万+', label: '全网爆料追踪' },
    { value: '实时', label: '热点即时推送' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20theatrical%20stage%20with%20red%20velvet%20curtains%20partially%20drawn%2C%20spotlight%20illuminating%20center%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%20with%20warm%20crimson%20and%20gold%20tones%2C%20entertainment%20industry%20vibe%2C%20luxurious%20texture%2C%20dramatic%20shadows%2C%20no%20text%2C%20abstract%20theatrical%20composition&width=1800&height=900&seq=hero-bg-chigua&orientation=landscape"
          alt="吃瓜网每日大赛 - 娱乐八卦爆料"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse-soft"></span>
              <span className="text-primary-300 text-sm font-medium">🔥 今日最新爆料已更新</span>
            </div>

            <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-4">
              吃瓜网每日大赛
              <br />
              <span className="text-primary-300">全网最热娱乐八卦一手掌握</span>
            </h1>

            <p className="text-white/70 text-base md:text-lg font-medium mb-6 max-w-xl lg:max-w-none">
              超人气娱乐八卦风向标
            </p>

            <p className="text-white/60 text-sm md:text-base leading-relaxed max-w-xl lg:max-w-none mb-8">
              吃瓜网每日大赛每日实时追踪娱乐圈最火爆料，第一时间曝光明星大瓜与最新黑料。
              从影视综艺到音乐时尚，从顶流绯闻到圈内秘辛，我们汇聚全网最全八卦最新消息，
              让你不错过任何一条爆款话题。无论是热门剧透、综艺翻车、恋情实锤还是合约风波，
              这里都有你想看的吃瓜爆料。今日吃瓜已就位，速来围观。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-300">
                    {s.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/50 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                立即吃瓜 <i className="ri-arrow-right-line ml-1"></i>
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-medium text-sm rounded-lg border border-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                查看热度排行 <i className="ri-fire-line ml-1"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-lg">
              <div className="absolute inset-0 bg-primary-500/20 rounded-2xl blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20illustration%20of%20entertainment%20news%20and%20gossip%20collage%2C%20newspaper%20clippings%20with%20bold%20headlines%20floating%2C%20camera%20flashes%2C%20spotlight%20effects%2C%20red%20carpet%20texture%2C%20dark%20theatrical%20background%2C%20vibrant%20red%20and%20gold%20accents%2C%20dramatic%20composition%2C%20editorial%20design%20style%2C%20no%20readable%20text&width=900&height=1100&seq=hero-visual-chigua&orientation=portrait"
                alt="吃瓜网每日大赛 - 娱乐八卦爆料主题视觉"
                className="relative z-10 w-full h-auto rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}